// Shared filter metadata for the Leads page — mirrors the backend's qualifying-filter rules

export const QUALIFYING_FILTER_KEYS = ['q', 'jobTitle', 'seniority', 'department', 'industry', 'country', 'state', 'city', 'employeeCount', 'revenue'];

export const MULTI_FILTER_KEYS = ['seniority', 'department', 'industry', 'country', 'state', 'employeeCount', 'revenue'];

export const MIN_QUALIFYING_FILTERS = 2;

export const countQualifyingFilters = (filters) =>
  QUALIFYING_FILTER_KEYS.reduce((n, key) => {
    const v = filters[key];
    if (Array.isArray(v)) return n + (v.length ? 1 : 0);
    return n + (typeof v === 'string' && v.trim() ? 1 : 0);
  }, 0);

export const SENIORITY_OPTIONS = [
  { value: 'c_level', label: 'C-Level / Founder' },
  { value: 'vp_level', label: 'VP' },
  { value: 'director_level', label: 'Director' },
  { value: 'manager_level', label: 'Manager' },
];

export const EMPLOYEE_COUNT_OPTIONS = [
  { value: '1-10', label: '1–10' },
  { value: '11-50', label: '11–50' },
  { value: '51-200', label: '51–200' },
  { value: '201-500', label: '201–500' },
  { value: '501-1000', label: '501–1,000' },
  { value: '1001-5000', label: '1,001–5,000' },
  { value: '5001-', label: '5,000+' },
];
